import { defineSlotRecipe } from '@chakra-ui/react';
import { radioGroupAnatomy } from '@chakra-ui/react/anatomy';

export const radioGroupSlotRecipe = defineSlotRecipe({
  className: 'chakra-radio-group',
  slots: radioGroupAnatomy.keys(),
  base: {
    item: {
      display: 'inline-flex',
      alignItems: 'center',
      cursor: 'pointer',
    },
    itemControl: {
      display: 'inline-flex',
      alignItems: 'center',
      justifyContent: 'center',
      flexShrink: 0,
      width: '24px !important',
      height: '24px !important',
      borderRadius: 'full',
      borderWidth: '2px !important',
      borderStyle: 'solid',
      borderColor: 'border.tertiary !important',
      bg: 'transparent !important',
      _focusVisible: {
        outline: '2px solid',
        outlineColor: 'border.action',
        outlineOffset: '2px',
      },
      _checked: {
        borderColor: 'defaultSafety.primary !important',
        bg: 'transparent !important',
      },
      '& .dot': {
        height: '12px !important',
        width: '12px !important',
        borderRadius: 'full',
        bg: 'defaultSafety.primary !important',
        scale: '1 !important',
      },
    },
  },
  variants: {
    variant: {
      outline: {
        itemControl: {
          borderColor: 'border.tertiary !important',
          bg: 'transparent !important',
          _checked: {
            borderColor: 'defaultSafety.primary !important',
            bg: 'transparent !important',
          },
          '& .dot': {
            bg: 'defaultSafety.primary !important',
            scale: '1 !important',
          },
        },
      },
      subtle: {},
      solid: {},
    },
    size: {
      xs: {},
      sm: {},
      md: {},
      lg: {},
    },
  },
  defaultVariants: {
    size: 'md',
    variant: 'outline',
  },
});
